import type {
  HTMLMotionProps,
  MotionValue,
  SpringOptions,
  Transition,
  UseInViewOptions,
  Variants,
} from "motion/react";
import type { ExtendProps } from "@/lib/types";

/*
 * Counting Numbers Text
 */
export type CountingNumberProps = ExtendProps<"span"> & {
  number: number;
  fromNumber?: number;
  padStart?: boolean;
  inView?: boolean;
  inViewMargin?: UseInViewOptions["margin"];
  inViewOnce?: boolean;
  decimalSeparator?: string;
  transition?: SpringOptions;
  decimalPlaces?: number;
};

/*
 * Sliding Number Text
 */
export type SlidingNumberRollerProps = ExtendProps<
  "span",
  {
    prevValue: number;
    value: number;
    place: number;
    transition: SpringOptions;
  }
>;

export type SlidingNumberDisplayProps = ExtendProps<
  "span",
  {
    motionValue: MotionValue<number>;
    number: number;
    height: number;
    transition: SpringOptions;
  }
>;

export type SlidingNumberProps = ExtendProps<
  "span",
  {
    number: number | string;
    inView?: boolean;
    inViewMargin?: UseInViewOptions["margin"];
    inViewOnce?: boolean;
    padStart?: boolean;
    decimalSeparator?: string;
    decimalPlaces?: number;
    transition?: SpringOptions;
  }
>;

/*
 * Splitting Text
 */
export type DefaultSplittingTextProps = {
  motionVariants?: {
    initial?: Record<string, any>;
    animate?: Record<string, any>;
    transition?: Record<string, any>;
    stagger?: number;
  };
  inView?: boolean;
  inViewMargin?: UseInViewOptions["margin"];
  inViewOnce?: boolean;
  delay?: number;
} & HTMLMotionProps<"div">;

export type CharsOrWordsSplittingTextProps = DefaultSplittingTextProps & {
  type?: "chars" | "words";
  text: string;
};

export type LinesSplittingTextProps = DefaultSplittingTextProps & {
  type: "lines";
  text: string[];
};

export type SplittingTextProps =
  | CharsOrWordsSplittingTextProps
  | LinesSplittingTextProps;

export const defaultItemVariant: Variants = {
  hidden: { x: 150, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

/*
 * Text Highlight
 */
export type TextHighlightProps = HTMLMotionProps<"span"> & {
  text: string;
  inView?: boolean;
  inViewMargin?: UseInViewOptions["margin"];
  inViewOnce?: boolean;
  transition?: Transition;
};
